import VerifyPhoneNumberScreen from 'features/myVaro/screens/PersonalDetails/ChangePhoneNumber/VerifyPhoneNumber/VerifyPhoneNumber';
import React from 'react';

export default function EnterCodePage() {
  return <VerifyPhoneNumberScreen />;
}
